import JOB_TYPE from '../../types/JobType.enum';

const jobs = [
  {
    company: 'jobs.alma',
    title: 'jobs.senior-web-dev',
    type: JOB_TYPE.JOB,
    year: 'year.april-2022-now',
    description: 'jobs.alma-description',
  },
  {
    company: 'jobs.ministry-defence',
    title: 'jobs.lead-web-dev',
    type: JOB_TYPE.JOB,
    year: 'year.2020-april-2022',
    description: 'jobs.ministry-description-2',
  },
  {
    company: 'jobs.ministry-defence',
    title: 'jobs.junior-web-dev',
    type: JOB_TYPE.JOB,
    year: 'year.2014-end-2019',
    description: 'jobs.ministry-description-1',
  },
  {
    company: 'jobs.supinfo',
    title: 'jobs.master-degree',
    type: JOB_TYPE.GRADUATION,
    year: 'year.2014',
    description: 'jobs.master-degree-description',
  },
  {
    company: 'jobs.frianbiz',
    title: 'jobs.internship',
    type: JOB_TYPE.INTERNSHIP,
    year: 'year.2012',
    description: 'jobs.frianbiz-description',
  },
  {
    company: 'jobs.accessline',
    title: 'jobs.internship',
    type: JOB_TYPE.INTERNSHIP,
    year: 'year.2011',
    description: 'jobs.accessline-description',
  },
  {
    title: 'jobs.scientific-bachelor-degree',
    type: JOB_TYPE.GRADUATION,
    year: 'year.2009',
  },
];

export default jobs;
